export const listeners = new Map();

const getListenersForEvent = (name) => listeners.get(name);

export const subscribe = (eventName, callback) => {
  if (!listeners.has(eventName)) {
    listeners.set(eventName, [callback]);
    return;
  }

  const callbacks = listeners.get(eventName);
  callbacks.push(callback);
  listeners.set(eventName, callbacks);
};

export const unsubscribe = (eventName, callback) => {
  const callbacks = listeners.get(eventName);
  listeners.set(
    eventName,
    callbacks.filter((current) => current !== callback)
  );
};

export const emit = (...params) => {
  const [eventName, ...eventParams] = params;
  const list = getListenersForEvent(eventName);
  if (Array.isArray(list)) {
    list.map((eventHandler) => eventHandler(...eventParams));
  }
};
